import config from '@/common/config';
import { urlencoded } from 'body-parser';
import index from './index.js';
const mixinName = {
  methods: {
    mx_thumbnailUrl(video) {
      if (video._poster) {
        return `${config.apiUrl}/medias/${index.api}/${video._poster.filename}/${video._poster.checksum}`;
      }
      return null;
    },
    mx_videoUrl(video) {
      return `${config.apiUrl}/medias/${index.api}/${video.filename}/${video.checksum}`;
    },
    mx_videoUrlWithDownloadName(video) {
      return this.mx_videoUrl(video) + `?fileTitle=${this.mx_videoDownloadName(this.video)}`;
    },
    mx_videoDownloadName(video) {
      return `${video.title}.${video.filename.substr(-3)}`;
    },
    mx_downloadFile(video) {
      let urlWithFileName = this.mx_videoUrlWithDownloadName(video);
      let filename = this.mx_videoDownloadName(video);
      console.debug('download file', urlWithFileName, filename);
      // Create a new anchor element
      const a = document.createElement('a');

      // Set the href and download attributes for the anchor element
      // You can optionally set other attributes like `title`, etc
      // Especially, if the anchor element will be attached to the DOM
      a.href = urlWithFileName;
      a.download = filename || 'download';
      a.click();
    },
  },
};
export default mixinName;
